import ContentsTypes from "@shared/enums/contentsTypes";
export const createDescriptionTabItem = (title, description, removeBgImage, sectionBgColor, borderColor, dynamiquePart) => ({
    key: "items",
    type: "DESCRIPTION_TABS_ITEM",
    value: "",
    children: [
        { key: "title", type: ContentsTypes.INPUT, value: title },
        { key: "description", type: ContentsTypes.INPUT, value: description },
        { key: "bgColor", type: ContentsTypes.COLOR, value: "#F6F6F9" },
        {
            children: [],
            key: "removeBgImage",
            type: "CHECKBOX",
            value: removeBgImage,
        },
        {
            children: [],
            key: "sectionBgColor",
            type: "COLOR",
            value: sectionBgColor,
        },
        {
            children: [],
            key: "borderColor",
            type: "COLOR",
            value: borderColor,
        },
        {
            key: "dynamicPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: dynamiquePart,
        },
    ],
});
